import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=32f73612&scoped=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=32f73612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f73612",
  null
  
)

export default component.exports